module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_5_1-d0cf443be542fa0fc3079e69a77e82c6.svg";